const isPhone = (phone: string): string | undefined => {
    return /^\(\d{3}\) \d{3}-\d{4}$/.test(phone) || phone === "" ? undefined : "Phone number is invalid";
}

export default isPhone;